import React from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Modals} from "../../component";
import {acceptLawyer, caseAccept} from "../../vendors/actions/case";

interface OwnProps {
    getUserInfo?: any

}

interface ConnectStateProps {
}

interface ConnectDispatchProps {
    selectLawyer: (data: {
        lawyer_id: number,
        case_uid: string
    }) => void,
}


const AcceptLawyerModal = (props: any) => {
    const {Modals: ModalActions, Case} = props;
    const {caseAccept} = ModalActions;
    const split = window.location.pathname.split('/');
    const case_uid = split[split.length - 1];
    let lawyer: {
        first_name: string,
        last_name: string,
        Lawyer?: any
    } | null = null;
    if (caseAccept && caseAccept?.lawyer_id) {
        lawyer = Case?.interestedLawyers.find((l: any) => l.lawyer_id === caseAccept?.lawyer_id);
    }

    const ignoreAcceptLawyer = () => {
        props.caseAccept(false)
    };

    const selectLawyer = () => {
        if (caseAccept && typeof caseAccept.lawyer_id === 'number') {
            props.selectLawyer({
                case_uid,
                lawyer_id: caseAccept.lawyer_id
            })
        }
    };


    return caseAccept && caseAccept.lawyer_id ? (
        <Modals.Question title={`Are you sure you want to accept ${lawyer?.Lawyer.name}'s proposal?`}
                        open={true}
                        icon={'lightbulb'}
                        cancelable={{
                            buttonTitle: 'Never Mind',
                            action: ignoreAcceptLawyer
                        }}
                        submit={{
                            buttonTitle: 'Accept',
                            action: selectLawyer
                        }}
                        iconIsVisible={true}/>
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout, Modals, Case} = state;
    return {
        Modals,
        Layout,
        Case
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        caseAccept: (data: any) => dispatch(caseAccept(data)),
        selectLawyer: (data: {
            case_uid: string,
            lawyer_id: number
        }) => dispatch(acceptLawyer(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AcceptLawyerModal);


